export interface VariablePlanilla {
  idVariable: number;
  categoria: string;
  codigo: string;
  descripcion: string;
  tipo: string;
  valor: string;
  orden: number;
  esSistema: boolean;
  activo: boolean;
  vigenciaDesde: string;
}

export const CATEGORIAS: Record<string, string> = {
  REMUNERACION: 'Remuneración',
  BENEFICIOS: 'Beneficios Laborales',
  APORTES: 'Aportes y Contribuciones',
  RENTA_5TA: 'Renta de 5ta Categoría',
  HORAS_EXTRA: 'Horas Extra',
};

export const initialVariable: VariablePlanilla = {
  idVariable: 0,
  categoria: 'BENEFICIOS',
  codigo: '',
  descripcion: '',
  tipo: 'decimal',
  valor: '',
  orden: 0,
  esSistema: false,
  activo: true,
  vigenciaDesde: new Date().toISOString().split('T')[0],
};
